/**
 * LocalStorage keys used throughout the application
 * These persist across browser sessions
 */
export const LocalStorageKeys = {
  devicePreferences: 'device-preferences'
} as const;
